import styled from 'styled-components';

import type {
  PurchaseWebCampaignOffer,
  ProductType,
} from '@xing-com/crate-common-graphql-types';
import type { ContractPrice } from '@xing-com/crate-upsell-utils';
import { spaceXXS, spaceXL } from '@xing-com/tokens';

import { BestSellerFlag } from './best-seller-flag';
import { OfferBoxPicker } from './offer-box-picker';
import { PricingBox } from './pricing-box';

export type OfferPickerProps = Pick<PurchaseWebCampaignOffer, 'contracts'> & {
  id: string;
  price: ContractPrice;
  product: ProductType;
  isBestSeller: boolean;
  toggleContract: (id: string) => void;
  className?: string;
};

export function OfferPicker({
  id,
  isBestSeller,
  product,
  price,
  contracts,
  toggleContract,
  className = '',
}: OfferPickerProps): JSX.Element {
  return (
    <div className={className}>
      <div>
        <StyledBestSellerFlag visible={isBestSeller} product={product} />
        <StyledPricingBox price={price} isAlwaysWrapped />
      </div>
      <OfferBoxPicker
        product={product}
        contracts={contracts}
        activeContractId={id}
        onContractChange={toggleContract}
      />
    </div>
  );
}

const StyledBestSellerFlag = styled(BestSellerFlag)`
  margin-bottom: ${spaceXXS};
`;

const StyledPricingBox = styled(PricingBox)`
  margin-bottom: ${spaceXL};
`;
